import { Resume } from 'packages/types'
import { SPACING } from 'builder/modules/constants'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { SpacingChangeHandler } from 'builder/modules/resumeEditor'
import { HorizontalSlider } from 'builder/components/HorizontalSlider'
import { useTextCustomization } from '../../hooks/useTextCustomization'
import { SliderContainer, ValueContainer, Value } from './styles'

type Props = {
  resume: Resume
  handleSpacingChange?: SpacingChangeHandler
}

// Converts the value to a user-friendly format [50%, 150%]
const prettify = (value: number) => `${100 + Math.round(50 * value)}%`

export const SpacingSlider = (props: Props) => {
  const { resume, handleSpacingChange } = props
  const { supportsSpacing, spacing } = useTextCustomization(resume)
  const { i18n } = useI18n()
  const { isAboveTablet } = useMediaQueries()

  const onChange = (value: number | number[]) => {
    const newValue = Array.isArray(value) ? value[0] : value
    handleSpacingChange?.(newValue, spacing)
  }

  return (
    <TooltipV2
      value={i18n.t(
        'builder.resume_editor.document_customization.sidebar.text_tab.spacing_customization_warning',
      )}
      width={250}
      multiline={true}
      position="bottom"
      isActive={!supportsSpacing}
    >
      <SliderContainer
        data-testid="spacing-slider-container"
        data-value={spacing}
        data-value-prettified={prettify(spacing)}
      >
        {!isAboveTablet && (
          <ValueContainer>
            <Value>{prettify(SPACING.min)}</Value>
          </ValueContainer>
        )}
        <HorizontalSlider
          disabled={!supportsSpacing || !handleSpacingChange}
          defaultValue={0}
          value={spacing}
          step={SPACING.step}
          min={SPACING.min}
          max={SPACING.max}
          onChange={onChange}
        />
        {!isAboveTablet && (
          <ValueContainer>
            <Value>{prettify(SPACING.max)}</Value>
          </ValueContainer>
        )}
        {isAboveTablet && (
          <ValueContainer>
            <Value>{prettify(spacing)}</Value>
          </ValueContainer>
        )}
      </SliderContainer>
    </TooltipV2>
  )
}
